module.exports = __webpack_public_path__ + "img/logo.a415e5a0.svg";